import { render, staticRenderFns } from "./MandateInfo.vue?vue&type=template&id=c1c05890&"
import script from "./MandateInfo.vue?vue&type=script&lang=ts&"
export * from "./MandateInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports